import { ReactComponent as FileSVG } from 'assets/file.svg';
import { ReactComponent as RemoveSVG } from 'assets/x.svg';
import './styles.scss';
const ListItem = ({ id, title, check, removable, selected, handleSelected, onRemove }) => {
  return (
    <li className="listItem">
      <label className="listItem__label" htmlFor={id} title={title}>
        {check ? (
          <input className="listItem__check" type="checkbox" name={id} id={id} checked={selected} onChange={handleSelected} />
        ) : (
          <FileSVG className="listItem__icon" />
        )}
        {title}
      </label>
      {removable && <RemoveSVG className="listItem__remove" onClick={onRemove} />}
    </li>
  );
};

export default ListItem;
